import {Form, message} from 'antd';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useHistory, useRouteMatch} from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import useLoading from '../../../../hooks/useLoading';
import {defSelector, fetchDEF, fetchDEFs} from '../../../../store/empresa';
import {valuesToFormData} from '../../../../util/formData';
import unwrapAxiosPromise from '../../../../util/unwrapAxiosPromise';
import EmpresaDEFForm from './_form';
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaDEFEditPage() {
  const {t} = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const def = useSelector(defSelector);
  const loading = useLoading(fetchDEF.typePrefix);
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const {moduloBasePath} = useModulo();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(def);
    setImmediate(() => document.querySelector('#dataApresentacao').focus());
  }, [def]);

  const handleFinish = values => {
    setLoadingSave(true);
    const formData = valuesToFormData(values);
    unwrapAxiosPromise(axios.put(`/empresas/${empresaId}/defs/${id}`, formData), form)
        .then(() => {
          message.success(t('Registro alterado com sucesso'));
          history.replace(`${moduloBasePath}/empresas/${empresaId}/defs/${id}`);
          dispatch(fetchDEFs({empresaId}));
          dispatch(fetchDEF({empresaId, id}));
        })
        .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/defs/${id}`);
  };

  const title = (
      <ActionBar>
        <ActionButton.Save onClick={form.submit} loading={loadingSave} />
        <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
      </ActionBar>);

  return (
      <EmpresaDEFForm
          disabled={loadingSave}
          disabledDataReferencia
          form={form}
          loading={loading}
          onFinish={handleFinish}
          title={title}
      />);
}
